export default {
  highlightColor: '#7C4DFF', // Solid lavender https://design.inrupt.com/atomic-core/?cat=Core

  formBorderColor: '#888888', // Mid-grey
  formHeadingColor: '#888888', // originally was brown; now grey
  lowProfileLinkColor: '#3B5998', // Grey-blue, e.g., for field labels linking to ontology
  formFieldNameBoxWidth: '8em', // The fixed amount to get form fields to line up
  // We put in the latter when switching away from using tables.  However, getting
  // alignment between fields in different groups is a hard problem.

  mediaModuleCanvasWidth: '640',
  mediaModuleCanvasHeight: '480',

  textInputSize: 20, // Rough default text input size, in characters
  tabBorderRadius: '0.2em',

  textInputBackgroundColor: '#eef',
  textInputBackgroundColorUneditable: '#fff',
  textInputColor: '#000',
  textInputColorPending: '#888',

  defaultErrorBackgroundColor: '#fee',

  participationDefaultBackground: 'white',

  basicMaxLength: '4096'
}
